import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

// Bootstrap
import { Carousel, Jumbotron } from 'react-bootstrap';

// Images
import Freetakistan from '../../assets/images/Freetakistan.png';
import Arma from '../../assets/images/arma2.png';
import Rfactor from '../../assets/images/rfactor.png';
import ArmaIcon from '../../assets/images/armaWallPaper.jpg'
import RfactorIcon from '../../assets/images/rfactorWallPaper.jpg'

// Components
import Header from '../../components/Header/index';

// Material-ui
import { Button, Card, CardActionArea, CardContent, CardMedia, CardActions, Typography, CardHeader } from '@material-ui/core';

// Context
import AuthContext from '../../Context/context';

// Firebase
import { db } from '../../utils/firebaseConfig';

import './home.css';

const Home = () => {
  let history = useHistory();
  const { isLogged, emailVerified } = useContext(AuthContext);

  // Dia e hora da atualização dos mods ativos dos servidores, será vázio caso não exista uma configuração
  const [timeUpdatedArma, setTimeUpdatedArma] = useState('');
  const [timeUpdatedRfactor, setTimeUpdatedRfactor] = useState('');

  useEffect(() => {
    GetModsAtivos();
  }, [])

  const GetModsAtivos = () => {
    db.collection('ModsAtivosRfactor').onSnapshot(resp => {
      // eslint-disable-next-line array-callback-return
      resp.docs.map((m) => {
        if (m.exists) {
          // Define o horario que foi atualizado o documento
          setTimeUpdatedRfactor(new Date(m.data().timeUpdated.toDate()).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' }))
        }
      })
    })

    db.collection('ModsAtivosArma').onSnapshot(resp => {
      // eslint-disable-next-line array-callback-return
      resp.docs.map((m) => {
        if (m.exists) {
          // Define o horario que foi atualizado o documento
          setTimeUpdatedArma(new Date(m.data().timeUpdated.toDate()).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' }))
        }
      })
    })
  }

  return (
    <div>
      <Header />
      <Carousel className="img-container">
        <Carousel.Item>
          <img
            id="img1"
            className="d-block w-100"
            src={Arma}
            alt="First slide"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            id="img2"
            className="d-block w-100"
            src={Rfactor}
            alt="Second slide"
          />
        </Carousel.Item>
      </Carousel>
      <Jumbotron className="text-center">
        <img src={Freetakistan} alt='Freetakistan Logo' style={{ width: '150px', marginBottom: '1em' }} />

        <h1>Free Takistan</h1>
        <p>
          Uma comunidade focada em jogos de simulação militar e automobilística, com o objetivo de divulgar informação e crescimento mútuo!
            </p>
        <p>
          {
            !isLogged &&
            <div>
              <Button variant='contained' id="btn-padrao" href='/login'>Login</Button><Button variant="contained" id="btn-padrao" href='/cadastro' style={{ marginLeft: '40px' }}>Cadastrar</Button>
            </div>
          }
        </p>
      </Jumbotron>

      <div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: '4em', marginBottom: '4em' }}>
        {
          timeUpdatedRfactor !== '' &&
          <Card style={{ maxWidth: 345 }}>
            <CardHeader
              title="Mods rodando no servidor de rFactor 2"
              subheader={`Atualizado dia ${timeUpdatedRfactor}`}
            />
            <CardActionArea>
              <CardMedia
                component="img"
                alt="rFactor 2"
                height="180"
                image={RfactorIcon}
                title="Mods rodando atualmente no servidor de rFactor 2"
              />
              <CardContent>
                <Typography variant="body2" color="textSecondary" component="p">
                  Estes são os mods que estão rodando atualmente no servidor de rFactor 2. Baixe todos que você não tem para conseguir entrar!
              </Typography>
              </CardContent>
            </CardActionArea>
            <CardActions>
              <Button size="small" color="primary" onClick={() => {
                history.push('/mods-ativos/rfactor');
              }}>
                {'Ver Mods'/*emailVerified ? 'Ver Mods' : 'Faça login para ver os Mods'*/}
              </Button>
            </CardActions>
          </Card>
        }

        {
          timeUpdatedArma !== '' &&
          <Card style={{ maxWidth: 345 }}>
            <CardHeader
              title="Mods rodando no servidor de Arma 2"
              subheader={`Atualizado dia ${timeUpdatedArma}`}
            />
            <CardActionArea>
              <CardMedia
                component="img"
                alt="Arma 2"
                height="180"
                image={ArmaIcon}
                title="Mods rodando atualmente no servidor de Arma 2"
              />
              <CardContent>
                <Typography variant="body2" color="textSecondary" component="p">
                  Estes são os mods que estão rodando atualmente no servidor de Arma 2. Baixe todos que você não tem para conseguir entrar!
              </Typography>
              </CardContent>
            </CardActionArea>
            <CardActions>
              <Button size="small" color="primary" onClick={() => {
                history.push('/mods-ativos/arma');
              }}>
                {'Ver Mods'/*emailVerified ? 'Ver Mods' : 'Faça login para ver os Mods'*/}
              </Button>
            </CardActions>
          </Card>
        }
      </div>
    </div>
  );
}

export default Home;